// utils/rem.js
export function setRemUnit(designWidth = 1920) {
    const docEl = document.documentElement;
    const clientWidth = docEl.clientWidth || window.innerWidth;

    if (!clientWidth) return;

    // 计算根字体大小，例如设计稿1920px，根字体设为10px
    const baseSize = 16

    const scale = document.documentElement.clientWidth / designWidth

    //设置页面根节点字体大小, 字体大小最小为12
    let fontSize = baseSize * Math.min(scale, 2) > 12 ? baseSize * Math.min(scale, 2) : 12

    // 设置根字体大小
    docEl.style.fontSize = `${fontSize}px`;
}

// 初始化
export function initRem(designWidth = 1920) {
    setRemUnit(designWidth);

    // 监听窗口大小变化
    window.addEventListener('resize', () => {
        setRemUnit(designWidth);
    });

    // 监听页面方向变化
    window.addEventListener('orientationchange', () => {
        setRemUnit(designWidth);
    });
}
